import React from 'react';
import {NavLink} from 'react-router-dom';
import {Translate} from '../../../config/TranslationProvider';
import SingleMedia from './SingleMedia';
import {parse as queryParse} from 'querystring';
import {useLocation} from 'react-router';

const DefaultHeader = ({customFilter = false, image, title}) => {
    const {search} = useLocation();
    // Get the filter query from the url
    const {filter: filterString} = queryParse(search.substr(1));
    // Check if the filter is from the api
    const isCustomFilter = customFilter ? Object.values(customFilter).find(({slug}) => slug === filterString) : false;

    return (
        <section className="bgimage header-breadcrumb overlay overlay--dark">
            <SingleMedia media={image} />

            <div className="breadcrumb-wrapper content_above">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <h1 className="page-title">{isCustomFilter?.filter_title ? isCustomFilter.filter_title : title}</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <NavLink to="/" aria-label="homepage">
                                            <Translate value="home" />
                                        </NavLink>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">{title}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DefaultHeader;
